import { format } from 'date-fns';
import { ref, update } from 'firebase/database';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { database } from '../../Common/Firebase';
import GetHomeworkComp from '../../pages/CreateHomework/GetHomeworkComp';
import StudentHomeworkItem from '../../pages/CreateHomework/StudentHomeworkItem';
import { getNotificationFlagUser, getUserType } from '../../redux/slices/userSlice';

import './style.scss';
import 'react-toggle/style.css';

export const PopupHomework = ({ homeworkObj, closeHomework, saveContent, handleEvent }) => {
  const { t } = useTranslation();
  const [getHomeworkState, setGetHomeworkState] = useState({});
  const [subArrayCheckedsState, setSubArrayCheckedsState] = useState([]);
  const [homeworkObjState, setHomeworkObjState] = useState({});
  const [exumObj, setExumObj] = useState({});
  const [flagEventNativ, setFlagEventNativ] = useState(false);
  const [eventHandled, setEventHandled] = useState(false);
  const userTypeSelector = useSelector(getUserType);
  const notificationFlagUser = useSelector(getNotificationFlagUser);
  const [stateObjChecked, setStateObjChecked] = useState({});

  const setCheckedHomework = (mail, elementHomework, checkArray, isChecked, subItems, id, subIndex) => {
    try {
      const now = new Date();
      const formattedTime = format(now, 'dd MM yyyy HH:mm');
      if (subItems) {
        setStateObjChecked({
          mail: mail,
          id: id,
          item: {
            subArrayCheckeds: checkArray,
          },
        });
        update(ref(database, `Students/${mail}/homeworks/${id}`), {
          subArrayCheckeds: checkArray,
        });

        if (isChecked) {
          const homeWork = elementHomework.find(it => it.id === homeworkObj.item);

          update(ref(database, `Teachers/${homeWork.mail}/notification`), {
            [id + subIndex]: {
              id: id + subIndex,
              idItem: id,
              mail: mail,
              name: homeWork.name,
              titles: homeWork.titles,
              time: formattedTime,
              point: subIndex + 1,
              subject: homeWork.subject,
              type: 'homeworks-student homeworks-points setItemPointHomeworkChecked',
              viewed: true,
            },
          });
        }
      } else {
        setStateObjChecked({
          mail: mail,
          id: id,
          item: {
            completed: isChecked,
          },
        });
        update(ref(database, `Students/${mail}/homeworks/${id}`), {
          completed: isChecked,
        });
        if (isChecked) {
          update(ref(database, `Teachers/${elementHomework.mail}/notification`), {
            [id]: {
              id: id,
              idItem: id,
              mail: mail,
              name: elementHomework.name === undefined ? elementHomework.homeworkName : elementHomework.name,
              time: formattedTime,
              subject: elementHomework.subject,
              type: 'homeworks-student homework setItemPointHomeworkChecked',
              viewed: true,
            },
          });
        }
      }
    } catch (error) {
      console.error('Error updating the database:', error);
    }
  };

  const setGetHomeworkFunc = (id, item) => {
    setGetHomeworkState(prevState => {
      return {
        ...prevState,
        [id]: {
          item: item,
          id: id,
        },
      };
    });
  };

  const closePopup = () => {
    if (stateObjChecked && Object.keys(stateObjChecked).length > 0) {
      try {
        update(ref(database, `Students/${stateObjChecked.mail}/homeworks/${stateObjChecked.id}`), stateObjChecked.item);
      } catch (error) {
        console.log(error);
      }
    }
    closeHomework();
  };

  useEffect(() => {
    if (Array.isArray(homeworkObj.arrAtributsHomeworksObjNew)) {
      const matchingItem = homeworkObj.arrAtributsHomeworksObjNew.find(obj => obj.id === homeworkObj.item);

      if (matchingItem) {
        setHomeworkObjState(matchingItem);

        if (Array.isArray(matchingItem.subArrayCheckeds)) {
          setSubArrayCheckedsState([...matchingItem.subArrayCheckeds]);
        } else {
          setSubArrayCheckedsState([matchingItem.subArrayCheckeds]);
        }
      } else {
        setHomeworkObjState({});
      }
    }
  }, [homeworkObj]);

  const handleCheckboxChange = (index, value) => {
    if (homeworkObjState && homeworkObjState.titles && homeworkObjState.titles.length > 1) {
      // If subItems is true

      const updatedCheckeds = [...subArrayCheckedsState];
      updatedCheckeds[index] = value;
      setSubArrayCheckedsState(updatedCheckeds);
      setCheckedHomework(
        homeworkObj.mail,
        homeworkObj.arrAtributsHomeworksObjNew,
        updatedCheckeds,
        value,
        true,
        homeworkObjState.id,
        index,
      );
    } else {
      // If subItems is false

      setHomeworkObjState(prevHomeworkObjState => ({
        ...prevHomeworkObjState,
        completed: value,
      }));
      setCheckedHomework(homeworkObj.mail, homeworkObjState, '', value, false, homeworkObjState.id);
    }
  };

  const handleMouseOver = () => {
    if (!eventHandled && typeof saveContent === 'function') {
      saveContent();
      setEventHandled(true);
    }
  };

  const handleMouseLeave = () => {
    setEventHandled(false);
  };

  const handleTouchStart = () => {
    if (!eventHandled && typeof saveContent === 'function') {
      saveContent();
      setEventHandled(true);
    }
  };

  useEffect(() => {
    if (flagEventNativ !== notificationFlagUser && typeof handleEvent === 'function') {
      handleEvent();
    }
  }, [notificationFlagUser]);

  return (
    <>
      <div className="hidden">
        {homeworkObj && homeworkObj.deadline !== '' && (
          <GetHomeworkComp content={homeworkObj.targetItem} setGetHomework={setGetHomeworkFunc} />
        )}
      </div>

      <div
        className={`popup-homework ${homeworkObj.positionNameAction}`}
        id="popup-homework-id-view"
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleTouchStart}
      >
        <div className="popup-homework-content">
          {homeworkObj.deadline === '' && (
            <>
              <button className="btn btn-icon close-btn" onClick={e => closePopup()}>
                <span className="icon icon-plus"></span>
              </button>

              {Object.values(exumObj).length > 0 && (
                <>
                  <h2>{t('exam') + ': ' + homeworkObj.homeworkName}</h2>
                  <StudentHomeworkItem content={exumObj} />
                </>
              )}
            </>
          )}

          {homeworkObj.deadline !== '' &&
            getHomeworkState &&
            Object.values(getHomeworkState)[0] &&
            Object.values(getHomeworkState)[0].item.length > 0 && (
              <>
                <h2>
                  {t('name') + ': '}
                  {homeworkObj.homeworkName}
                </h2>
                <span>
                  {t('deadlineHomework')}
                  {' ' + homeworkObj.deadline}
                </span>
                <button className="btn btn-icon close-btn" onClick={e => closePopup()}>
                  <span className="icon icon-plus"></span>
                </button>

                <div className="wrap-homework">
                  {getHomeworkState &&
                  Object.values(getHomeworkState)[0] &&
                  Object.values(getHomeworkState)[0].item.length > 0 &&
                  homeworkObj.targetSubItem &&
                  homeworkObj.titels.length > 1
                    ? Object.values(getHomeworkState)[0].item.map((item, i) => {
                        if (homeworkObj.titels[i] === homeworkObj.targetSubItem) {
                          return (
                            <React.Fragment key={i}>
                              <div className="name-homework-row">
                                {getHomeworkState &&
                                  Object.values(getHomeworkState)[0] &&
                                  Object.values(getHomeworkState)[0].item.length > 1 &&
                                  (homeworkObj.titels ? (
                                    <span>{homeworkObj.titels[i]}</span>
                                  ) : (
                                    <span>Пункт{' ' + (i + 1)}</span>
                                  ))}

                                <div className="name-homework-wrap">
                                  <span className="name-homework-span">{t('done')}</span>

                                  <input
                                    type="checkbox"
                                    className="checkbox-homework"
                                    checked={
                                      homeworkObjState && homeworkObjState.titles && homeworkObjState.titles.length > 1
                                        ? subArrayCheckedsState[i] || false
                                        : homeworkObjState.completed || false
                                    }
                                    onChange={e =>
                                      handleCheckboxChange(i, e.target.checked, Object.values(getHomeworkState)[0])
                                    }
                                    disabled={userTypeSelector !== 'Student'}
                                  />
                                  <label>
                                    <span className="name-homework"></span>
                                  </label>
                                </div>
                              </div>

                              <StudentHomeworkItem content={item} />
                            </React.Fragment>
                          );
                        }
                      })
                    : Object.values(getHomeworkState)[0].item.map((item, i) => {
                        return (
                          <React.Fragment key={i}>
                            <div className="name-homework-row">
                              {getHomeworkState &&
                                Object.values(getHomeworkState)[0] &&
                                Object.values(getHomeworkState)[0].item.length > 1 &&
                                (homeworkObj.titels ? (
                                  <span>{homeworkObj.titels[i]}</span>
                                ) : (
                                  <span>Пункт{' ' + (i + 1)}</span>
                                ))}

                              <div className="name-homework-wrap">
                                <span className="name-homework-span">{t('done')}</span>

                                <input
                                  type="checkbox"
                                  className="checkbox-homework"
                                  checked={
                                    homeworkObjState && homeworkObjState.titles && homeworkObjState.titles.length > 1
                                      ? subArrayCheckedsState[i] || false
                                      : homeworkObjState.completed || false
                                  }
                                  onChange={e =>
                                    handleCheckboxChange(i, e.target.checked, Object.values(getHomeworkState)[0])
                                  }
                                  disabled={userTypeSelector !== 'Student'}
                                />
                                <label>
                                  <span className="name-homework"></span>
                                </label>
                              </div>
                            </div>

                            <StudentHomeworkItem content={item} />
                          </React.Fragment>
                        );
                      })}
                </div>
              </>
            )}
        </div>
      </div>
    </>
  );
};
